import React, { Component } from 'react';
import styled from '@emotion/styled';
import { Header } from 'components';
import PropTypes from 'prop-types';
import { ProjectsActions, PaymentActions } from 'redux/actions';
import { connect } from 'react-redux';
import {
  Colors,
  Container,
  device,
  Modal,
  PrimaryButton,
  AddModal,
  AddInnerModalWrapper,
  PrimaryButtonV2,
  AddButtonWrapper,
} from 'utils';
import { Link, withRouter } from 'react-router-dom';
import {
  SideBar,
  BasicInformation,
  BasicsEdit,
  // Blog,
  CategorySelection,
  // CommunicationPlan,
  ContractDocuments,
  // Cooperations,
  // FeedBackAnswers,
  // FeedBackParticipants,
  FundingGoal,
  // ImprintAndBillingAddress,
  // MarketingReferrer,
  Media,
  // PartnerCampaigns,
  ProjectDescription,
  Rewards,
  StripeAccount,
  Submission,
  // Team,
  // VerificationOverview,
  // VoluntaryCommission,
  // Legitimation,
} from './components';
import ContactModal from 'scenes/Project/components/ContactModal';
import { InfoIconGreen } from 'images';

const ProjectFormWrapper = styled.div`
  .header-wrapper {
    position: relative;
    background: ${Colors.white};
    ul {
      li {
        color: ${Colors.black};
      }
    }
    .start-project {
      color: ${Colors.GreenColor};
    }
  }
  .relative-header {
    z-index: 1003;
    background: ${Colors.white};
  }
  .container {
    margin-top: 0;
    max-width: none;
    padding: 0;
  }
  .inside-form-container {
    margin-left: 12%;
    margin-right: 12%;
    width: 76%;
    @media ${device.maxLaptop} {
      margin: 0;
      width: 100%;
    }
  }
  .content-Wrapper {
    max-width: none;
    margin: auto;
    background: ${Colors.white};
  }
`;

const ProjectFormFormWrapper = styled.div`
  display: flex;
  flex-direction: row;
  min-height: calc(100vh);
  overflow-y: auto;
  overflow-x: hidden;
  @media ${device.maxLaptop} {
    display: none;
    flex-direction: column;
    min-height: 0;
  }
  .project-form__sidebar {
    min-height: calc(100vh);
    height: auto;
    @media ${device.maxLaptop} {
      min-height: 0;
    }
  }
  .project-form__content {
    padding: 20px;
    padding-top: 29px;
    margin-bottom: 44px;
    height: auto;
    width: 100%;
    direction: rtl;
    * {
      direction: ltr;
    }
    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
      display: none;
    }

    &::-webkit-scrollbar {
      width: 12px;
      background-color: #f5f5f5;
      display: none;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: ${Colors.secondaryColor};
      display: none;
    }
    input,
    select,
    textarea,
    .ant-select-selector {
      border-radius: 10px !important;
    }
    .ant-col-24.ant-form-item-label {
      padding: 0 !important;
    }
    textarea {
      // min-height: 200px;
    }
    .ant-picker {
      width: 100%;
      border-radius: 10px;
    }
    .ant-input-group {
      input {
        border-radius: 10px 0 0 10px !important;
      }
      .ant-input-group-addon {
        border-radius: 0 10px 10px 0;
      }
    }
    h1 {
      font-weight: bold;
      font-size: 30px;
      color: ${Colors.GreenColor};
      margin: 35px 0 22px 0;
      line-height: 1;
      text-align: left;
      @media ${device.maxLaptop} {
        margin: 0 0 16px 0;
      }
    }
    h2 {
      color: ${Colors.GreenColor};
      font-size: 20px;
      padding-bottom: 8px;
      margin: 10px 0 0;
    }
    p {
      font-size: 16px;
      margin: 0;
      padding-bottom: 16px;
      font-weight: 400;
      color: #535862;
    }
    @media ${device.maxLaptop} {
      margin-top: 16px;
      padding: 0;
    }
  }
`;
const GotoDiskTop = styled.div`
  display: none;
  @media ${device.maxLaptop} {
    display: block;
    margin: 150px 20px;
    text-align: center;
    border: 1px solid ${Colors.grey};
    border-radius: 15px;
    padding: 20px 10px;
    color: ${Colors.white};
    background: ${Colors.secondaryColor};
    h1 {
      color: ${Colors.white};
      font-weight: bold;
    }
  }
`;
const LockWrapper = styled.div`
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: #000;
    opacity: 0.7;
    z-index: 1000;
  }
  .text {
    position: fixed;

    left: 50%;
    transform: translateX(-50%);
    z-index: 1001;
    width: 750px;
    h1 {
      margin-top: 50px;
    }
    p,
    h1 {
      color: ${Colors.white};
    }
  }
  .link {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 50px;
    @media ${device.laptop} {
      font-size: 16px;
    }
    button {
      margin-left: 50px;
      margin-right: 50px;
    }
    a,
    button {
      display: inline-block;
      border-bottom: none;
      background: ${Colors.white};
      border: 1px solid ${Colors.secondaryColor};
      color: ${Colors.secondaryColor};
      text-align: center;
      border-radius: 12px;
      cursor: pointer;
      margin-bottom: 20px;
      padding: 15px 20px;
      min-width: 200px;
      font-size: 18px;
      @media ${device.laptop} {
        font-size: 16px;
      }
      &:hover {
        background: ${Colors.secondaryColor};
        color: ${Colors.white};
      }
    }
  }
`;
const MoveModal = styled.div`
  .actions {
    margin-top: 25px;
    display: flex;
    justify-content: space-between;
    button + button {
      background: #f44336;
      border: 1px solid #f44336;
      &:hover {
        background: ${Colors.transparent};
        border: 1px solid #f44336;
        color: #f44336;
      }
    }
  }
`;

const PrimaryLinkButton = styled.div`
  margin-top: 25px;
  display: block;
  background-color: #fff;
  padding: 10px;
  border-radius: 8px;
  color: #95bd51;
  line-height: 25px;
`;
class ProjectFormV2 extends Component {
  static propTypes = {
    updateDraft: PropTypes.func.isRequired,
    project: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    updateDraftAndImages: PropTypes.func.isRequired,
    updateDraftReward: PropTypes.func.isRequired,
    deleteDraftReward: PropTypes.func.isRequired,
    handleSteps: PropTypes.func.isRequired,
    currentStep: PropTypes.number.isRequired,
    reEditDraft: PropTypes.func.isRequired,
    getStripeStatus: PropTypes.func.isRequired,
    submitDraft: PropTypes.func.isRequired,
    setUpStripeAccountURL: PropTypes.func.isRequired,
    stripeStatus: PropTypes.string,
  };
  handleResize = () => {
    if (window.innerWidth < 1025) {
      this.setState({ mobileFormShow: true });
    } else {
      this.setState({ mobileFormShow: false });
    }
  };
  componentDidMount() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    const {
      updateDraft,
      getStripeStatus,
      handleSteps,
      match: {
        params: { id },
      },
    } = this.props;
    console.log('componentDidMount id:', id);
    id && updateDraft(id, {});
    id && getStripeStatus(id);
    id ? handleSteps(4) : handleSteps(1);
    id &&
      fetch('create_paypal_customer_account', {
        method: 'POST',
        body: JSON.stringify({
          project_id: id,
          return_url: window.location.href,
        }),
        redirect: 'follow',
      })
        .then((result) => {
          this.setpayPalStatus(result?.completed == undefined ? false : true);
        })
        .catch((err) => console.log('error'));
  }
  hasHandledSteps = false;
  componentDidUpdate(prevProps) {
    const {
      project,
      handleSteps,
      match: {
        params: { id },
      },
    } = this.props;
    const {
      basicInfo,
      projectDescription,
      fundingTarget,
      media,
      stripeStatus,
      contractDocuments,
    } = project;

    if (!this.hasHandledSteps && project !== prevProps.project) {
      if (contractDocuments?.isDone) handleSteps(9);
      else if (media?.isDone) handleSteps(7);
      else if (projectDescription?.isDone) handleSteps(6);
      else if (basicInfo?.isDone) handleSteps(5);
      else handleSteps(8);
      this.hasHandledSteps = true;
    }

    if (
      !this.state.editProject &&
      prevProps.project !== project &&
      project?.status !== 'draft' &&
      project?.status !== 'pending'
    ) {
      this.setState({ editProject: true });
      handleSteps(2);
    }

    if (this.state.editProject && project !== prevProps.project) {
      this.setState({ missingPages: [] });
      const projectSections = {
        basicInfo,
        projectDescription,
        fundingTarget,
        media,
        contractDocuments,
      };
      const missingPages = Object.entries(projectSections)
        .filter(([_, value]) => !value?.isDone)
        .map(([key]) => key);

      if (
        stripeStatus !== 'enabled_and_eventually_due' &&
        stripeStatus !== 'enabled'
      ) {
        missingPages.push('stripeStatus');
      }

      if (
        JSON.stringify(this.state.missingPages) !== JSON.stringify(missingPages)
      ) {
        this.setState({ missingPages });
      }
    }
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }
  state = {
    canMove: true,
    showModal: false,
    selectedStep: 0,
    submitFromModal: false,
    payPalStatus: false,
    mobileFormShow: false,
    status: null,
    editProject: false,
    missingPages: [],
    showExitEditFormModal: false,
  };
  setSelectedStep = (selectedStep) => this.setState({ selectedStep });
  setpayPalStatus = (payPalStatus) => this.setState({ payPalStatus });
  setCanMove = (canMove) => this.setState({ canMove });
  handelCloseModal = () => {
    this.setState({ showModal: false });
    document.body.style.overflowY = 'unset';
  };
  handleExitEditFormModal = () => {
    this.setState({ showExitEditFormModal: false });
  };
  setSubmitFromModal = (submitFromModal) => this.setState({ submitFromModal });
  handelShowModal = () => {
    this.setState({ showModal: true, submitFromModal: true });
    document.body.style.overflowY = 'hidden';
  };
  setHandleStatusChange = (status) => this.setState({ status });

  handelSaveAndMove = () => {
    const submitButton = document.getElementById('submit-button');
    submitButton.click();
    this.setCanMove(true);
    this.handelCloseModal();
  };

  render() {
    const {
      canMove,
      showModal,
      selectedStep,
      submitFromModal,
      mobileFormShow,
      editProject,
      missingPages,
    } = this.state;
    const {
      updateDraft,
      match: {
        params: { id },
      },
      project,
      updateDraftAndImages,
      updateDraftReward,
      deleteDraftReward,
      handleSteps,
      currentStep,
      stripeStatus,
    } = this.props;

    const isPending = Boolean(
      project &&
        (project.status === 'pending' ||
          project.status === 'accepted' ||
          project.status === 'edit_accepted' ||
          project.status === 'edit_pending' ||
          project.status === 'declined' ||
          project.status === 'edit_declined')
    );
    const isStripeDone = Boolean(
      stripeStatus === 'enabled_and_eventually_due' ||
        stripeStatus === 'enabled'
    );

    const handleCreateProject = (values) => {
      console.log('create values', values);
      fetch('create_project_draft_user', {
        method: 'POST',
        body: JSON.stringify({
          ...values,
          category_ids: [`${values.category_id}`],
        }),
        redirect: 'follow',
      })
        .then((result) => {
          console.log('result---> ', result);
          this.props.history.push(`/start-project/${result?.id}`);
        })
        .catch((err) => {
          console.log('error');
          return err;
        });
    };

    const returnToProfile = () => {
      this.props.history.push(`/profile`);
    }

    const handleExitEditForm = () => {
      this.setState({ showExitEditFormModal: true });
    };

    const handleContinueToProjectView = () => {
      const {
        match: {
          params: { id },
        },
      } = this.props;
      this.props.history.push(`/my-project/${id}`);
    };

    const handleLegitimization = () => {
      const {
        match: {
          params: { id },
        },
        setUpStripeAccountURL,
      } = this.props;
      setUpStripeAccountURL(
        id,
        project.business_type,
        project.categoryType.country
      );
    };

    const handleReLegitimization = () => {
      const {
        match: {
          params: { id },
        },
        project,
      } = this.props;

      const requestOptions = {
        method: 'GET',
        redirect: 'follow',
      };

      const user = JSON.parse(localStorage.getItem('user') || {});
      const email = user.email || '';
      const first_name = user.first_name || '';
      const last_name = user.last_name || '';
      const queryParams = new URLSearchParams({
        initiator_country: project.categoryType.country,
        business_type: project.business_type,
        email,
        first_name,
        last_name,
      });

      fetch(
        `/payments/${id}/restart_stripe_account?${queryParams.toString()}`,
        requestOptions
      )
        .then((res) => {
          window.open(res.url, '_self');
          return { res };
        })
        .catch((error) => {
          return Promise.reject({ errors: error });
        });
    };

    const handleSubmission = () => {
      const {
        match: {
          params: { id },
        },
        submitDraft,
      } = this.props;
      id && submitDraft(id);
    };

    const handleCurrentComponent = () => {
      const { currentStep } = this.props;
      switch (currentStep) {
        case 1:
          return (
            <CategorySelection
              updateDraft={updateDraft}
              projectId={id}
              setCanMove={this.setCanMove}
              showModal={submitFromModal}
              setSubmitFromModal={this.setSubmitFromModal}
              selectedStep={selectedStep}
              setSelectedStep={this.setSelectedStep}
            />
          );
        case 2:
          return (
            <StripeAccount
              updateDraft={updateDraft}
              projectId={id}
              setCanMove={this.setCanMove}
            />
          );
        case 3:
          return (
            <FundingGoal
              updateDraft={updateDraft}
              projectId={id}
              setCanMove={this.setCanMove}
              showModal={submitFromModal}
              setSubmitFromModal={this.setSubmitFromModal}
              selectedStep={selectedStep}
            />
          );
        case 4:
          return (
            <BasicInformation
              updateDraft={updateDraft}
              projectId={id}
              setCanMove={this.setCanMove}
              showModal={submitFromModal}
              setSubmitFromModal={this.setSubmitFromModal}
              selectedStep={selectedStep}
              handleCreateProject={handleCreateProject}
              setSelectedStep={this.setSelectedStep}
            />
          );
        case 5:
          return (
            <ProjectDescription
              updateDraft={updateDraft}
              projectId={id}
              setCanMove={this.setCanMove}
              showModal={submitFromModal}
              setSubmitFromModal={this.setSubmitFromModal}
              selectedStep={selectedStep}
            />
          );
        case 6:
          return (
            <Media
              updateDraft={updateDraft}
              projectId={id}
              updateDraftAndImages={updateDraftAndImages}
              setCanMove={this.setCanMove}
              showModal={submitFromModal}
              setSubmitFromModal={this.setSubmitFromModal}
              selectedStep={selectedStep}
            />
          );
        case 7:
          return (
            <Rewards
              updateDraft={updateDraft}
              updateDraftReward={updateDraftReward}
              deleteDraftReward={deleteDraftReward}
              projectId={id}
              setCanMove={this.setCanMove}
              showModal={submitFromModal}
              setSubmitFromModal={this.setSubmitFromModal}
              selectedStep={selectedStep}
            />
          );
        case 8:
          return (
            <ContractDocuments
              updateDraft={updateDraft}
              projectId={id}
              setCanMove={this.setCanMove}
              showModal={submitFromModal}
              setSubmitFromModal={this.setSubmitFromModal}
              selectedStep={selectedStep}
              mobileFormShow={mobileFormShow}
              handleSubmission={handleSubmission}
            />
          );

        case 9:
          return (
            <Submission
              updateDraft={updateDraft}
              projectId={id}
              setCanMove={this.setCanMove}
              showModal={submitFromModal}
              setSubmitFromModal={this.setSubmitFromModal}
              selectedStep={selectedStep}
              handleSubmission={handleSubmission}
              handleExitEditForm={handleExitEditForm}
              returnToProfile={returnToProfile}
              handleLegitimization={handleLegitimization}
              handleReLegitimization={handleReLegitimization}
            />
          );

        default:
          break;
      }
    };
    const handleEditComponent = () => {
      const { currentStep } = this.props;
      switch (currentStep) {
        case 1:
          return (
            <BasicsEdit
              updateDraft={updateDraft}
              projectId={id}
              setCanMove={this.setCanMove}
              showModal={submitFromModal}
              setSubmitFromModal={this.setSubmitFromModal}
              selectedStep={selectedStep}
              setSelectedStep={this.setSelectedStep}
              handleExitEditForm={handleExitEditForm}
            />
          );
        case 2:
          return (
            <BasicInformation
              updateDraft={updateDraft}
              projectId={id}
              setCanMove={this.setCanMove}
              showModal={submitFromModal}
              setSubmitFromModal={this.setSubmitFromModal}
              selectedStep={selectedStep}
              handleCreateProject={handleCreateProject}
              setSelectedStep={this.setSelectedStep}
              handleExitEditForm={handleExitEditForm}
              editProject={editProject}
            />
          );
        case 3:
          return (
            <ProjectDescription
              updateDraft={updateDraft}
              projectId={id}
              setCanMove={this.setCanMove}
              showModal={submitFromModal}
              setSubmitFromModal={this.setSubmitFromModal}
              selectedStep={selectedStep}
              handleExitEditForm={handleExitEditForm}
              editProject={editProject}
            />
          );
        case 4:
          return (
            <FundingGoal
              updateDraft={updateDraft}
              projectId={id}
              setCanMove={this.setCanMove}
              showModal={submitFromModal}
              setSubmitFromModal={this.setSubmitFromModal}
              selectedStep={selectedStep}
              handleExitEditForm={handleExitEditForm}
              editProject={editProject}
            />
          );
        case 5:
          return (
            <Media
              updateDraft={updateDraft}
              projectId={id}
              updateDraftAndImages={updateDraftAndImages}
              setCanMove={this.setCanMove}
              showModal={submitFromModal}
              setSubmitFromModal={this.setSubmitFromModal}
              selectedStep={selectedStep}
              handleExitEditForm={handleExitEditForm}
              editProject={editProject}
            />
          );
        case 6:
          return (
            <Rewards
              updateDraft={updateDraft}
              updateDraftReward={updateDraftReward}
              deleteDraftReward={deleteDraftReward}
              projectId={id}
              setCanMove={this.setCanMove}
              showModal={submitFromModal}
              setSubmitFromModal={this.setSubmitFromModal}
              selectedStep={selectedStep}
              handleExitEditForm={handleExitEditForm}
              editProject={editProject}
            />
          );
        case 7:
          return (
            <Submission
              updateDraft={updateDraft}
              projectId={id}
              setCanMove={this.setCanMove}
              showModal={submitFromModal}
              setSubmitFromModal={this.setSubmitFromModal}
              selectedStep={selectedStep}
              handleSubmission={handleSubmission}
              handleLegitimization={handleLegitimization}
              handleReLegitimization={handleReLegitimization}
              handleExitEditForm={handleExitEditForm}
              returnToProfile={returnToProfile}
              editProject={editProject}
            />
          );
        case 8:
          return (
            <ContractDocuments
              updateDraft={updateDraft}
              projectId={id}
              setCanMove={this.setCanMove}
              showModal={submitFromModal}
              setSubmitFromModal={this.setSubmitFromModal}
              selectedStep={selectedStep}
              mobileFormShow={mobileFormShow}
              handleExitEditForm={handleExitEditForm}
              editProject={editProject}
              handleSubmission={handleSubmission}
              missingPages={missingPages}
            />
          );

        default:
          break;
      }
    };

    return (
      <>
        {!mobileFormShow && <ContactModal />}
        <ProjectFormWrapper>
          <Header relativeHeader={true} projectForm={true} />
          <Container className="container">
            <>
              {/*((isPending && id) || status) && (
                <LockWrapper>
                  <div className="overlay"></div>
                  <div className="text">
                    {handelOverlayText(project.status)}
                    <div className="link">
                      <Link to={`/view/${id}`}>Vorschau</Link>
                      {/* <Link>Vorschau</Link> *}

                      <button
                        onClick={() => {
                          this.setState({ status: null });
                          reEditDraft(id);
                        }}
                      >
                        Projekt bearbeiten
                      </button>
                      <Link to={`/profile`}>Zurück zum Profil</Link>
                    </div>
                  </div>
                </LockWrapper>
              )*/}

              <ProjectFormFormWrapper
                pending={isPending}
                style={{ display: mobileFormShow ? 'flex' : '' }}
              >
                <div className="project-form__sidebar">
                  <SideBar
                    handelCurrentView={handleSteps}
                    currentView={currentStep}
                    projectId={id}
                    project={project}
                    isStripeDone={isStripeDone}
                    canMove={canMove}
                    handelShowModal={this.handelShowModal}
                    setSelectedStep={this.setSelectedStep}
                    getPayPalStatus={this.state.payPalStatus}
                    setStatus={this.setHandleStatusChange}
                    handelOverlayText={(status) => this.setState({ status })}
                    mobileFormShow={mobileFormShow}
                    editProject={editProject}
                  />
                </div>
                <div className="project-form__content">
                  {editProject
                    ? handleEditComponent()
                    : handleCurrentComponent()}
                </div>
              </ProjectFormFormWrapper>
            </>
          </Container>
        </ProjectFormWrapper>
        <Modal showModal={showModal} handelCloseModal={this.handelCloseModal}>
          <MoveModal>
            <p>
              Zuletzt durchgeführte Änderungen musst du speichern; diese gehen
              sonst verloren.
            </p>
            <div className="actions">
              <PrimaryButton onClick={this.handelSaveAndMove}>
                Speichern und schließen
              </PrimaryButton>
              <PrimaryButton
                onClick={() => {
                  handleSteps(selectedStep);
                  this.handelCloseModal();
                  this.setCanMove(true);
                }}
              >
                Schließen
              </PrimaryButton>
            </div>
          </MoveModal>
        </Modal>
        <AddModal
          showModal={this.state.showExitEditFormModal}
          handelCloseModal={this.handleExitEditFormModal}
          width="35%"
        >
          <AddInnerModalWrapper>
            <img
              style={{ height: '48px', width: '48px' }}
              src={InfoIconGreen}
              alt="Info icon"
            />
            <h2>Wichtiger Hinweis</h2>
            <p>
              Bitte beachte: Damit deine Änderungen auf deiner Projektseite
              angezeigt werden, musst du sie in jedem Bereich zunächst speichern
              und anschließend unter dem Reiter „Einreichung“ einreichen.
            </p>
            <AddButtonWrapper>
              <div className="space-between">
                <PrimaryButtonV2
                  type="button"
                  primary="true"
                  onClick={this.handleExitEditFormModal}
                >
                  <p>Zurück</p>
                </PrimaryButtonV2>

                <PrimaryButtonV2
                  type="primary"
                  onClick={handleContinueToProjectView}
                >
                  <p>Weiter</p>
                </PrimaryButtonV2>
              </div>
            </AddButtonWrapper>
          </AddInnerModalWrapper>
        </AddModal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { project, loading, errors, currentStep } = state.projects;
  const { stripeStatus } = state.payment;
  return {
    project,
    loading,
    errors,
    currentStep,
    stripeStatus,
  };
};

const mapDispatchToProps = (dispatch) => ({
  setUpStripeAccountURL: (projectId, business_type, initiator_country) =>
    dispatch(
      PaymentActions.setUpStripeAccountURL(
        projectId,
        business_type,
        initiator_country
      )
    ),
  getStripeStatus: (projectId) =>
    dispatch(PaymentActions.getStripeStatus(projectId)),
  updateDraft: (projectId, project, currentStep, submit) =>
    dispatch(
      ProjectsActions.updateDraft(projectId, project, currentStep, submit)
    ),
  // updateDraft: (projectId, project, currentStep = null) =>
  //   dispatch(ProjectsActions.updateDraft(projectId, project, currentStep)),
  updateDraftReward: (projectId, rewardJSON, rewardImage, currentStep) =>
    dispatch(
      ProjectsActions.updateDraftReward(
        projectId,
        rewardJSON,
        rewardImage,
        currentStep
      )
    ),
  deleteDraftReward: (projectId, rewardId, currentStep) =>
    dispatch(
      ProjectsActions.deleteDraftReward(projectId, rewardId, currentStep)
    ),
  updateDraftAndImages: (
    projectId,
    projectJSON,
    projectImages,
    currentStep
  ) => {
    dispatch(
      ProjectsActions.updateDraftAndImages(
        projectId,
        projectJSON,
        projectImages,
        currentStep
      )
    );
  },
  handleSteps: (step) => dispatch(ProjectsActions.handleSteps(step)),
  reEditDraft: (projectId) => dispatch(ProjectsActions.reEditDraft(projectId)),
  submitDraft: (projectId) => dispatch(ProjectsActions.submitDraft(projectId)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProjectFormV2)
);
